import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';

const bp = () => {
    const div = document.createElement('div');

    div.style.position = 'fixed';
    div.style.bottom = '10px';
    div.style.left = '10px';
    div.style.overflow = 'hidden';
    div.style.borderRadius = '5px';
    div.style.padding = '2.5px 10px';
    div.style.display = 'block';
    div.style.backgroundColor = 'black';
    div.style.color = 'white';
    div.style.cursor = 'pointer';
    div.style.opacity = '0.85';
    div.style.mozOpacity = '0.85';
    div.style.zIndex = '1000';

    div.innerHTML = `${MediaQuery.current}: ${window.innerWidth}px`;

    div.onclick = () => {
        div.style.bottom = '-100px';
    };

    window.onresize = () => {
        div.innerHTML = `${MediaQuery.current}: ${window.innerWidth}px`;
    };

    document.body.appendChild(div);

    return 'BP Display';
};

const hasClass = (el, className) => {
    let result = null;

    if (el !== null) {
        result = new RegExp(` ${className} `).test(` ${el.className} `);
    }

    return result;
};

const addClass = (el, className) => {
    if (el !== null) {
        if (!hasClass(el, className)) {
            el.className = `${el.className} ${className}`;
        }
    }
};

const setClass = (el, className) => {
    if (el !== null) {
        el.className = className;
    }
};

const removeClass = (el, className) => {
    if (el !== null) {
        let newClass = ` ${el.className.replace(/[\t\r\n]/g, ' ')} `;

        if (hasClass(el, className)) {
            while (newClass.indexOf(` ${className} `) >= 0) {
                newClass = newClass.replace(` ${className} `, ' ');
            }

            el.className = newClass.replace(/^\s+|\s+$/g, '');
        }
    }
};

const getStyle = (el, styleProp) => {
    /* eslint-disable */
    let value,
        defaultView = (el.ownerDocument || document).defaultView;
    // W3C standard way:
    if (defaultView && defaultView.getComputedStyle) {
        // sanitize property name to css notation
        // (hypen separated words eg. font-Size)
        styleProp = styleProp.replace(/([A-Z])/g, '-$1').toLowerCase();
        return defaultView
            .getComputedStyle(el, null)
            .getPropertyValue(styleProp);
    } else if (el.currentStyle) {
        // IE
        // sanitize property name to camelCase
        styleProp = styleProp.replace(/\-(\w)/g, function (str, letter) {
            return letter.toUpperCase();
        });
        value = el.currentStyle[styleProp];
        // convert other units to pixels on IE
        if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
            return (function (value) {
                let oldLeft = el.style.left,
                    oldRsLeft = el.runtimeStyle.left;
                el.runtimeStyle.left = el.currentStyle.left;
                el.style.left = value || 0;
                value = el.style.pixelLeft + 'px';
                el.style.left = oldLeft;
                el.runtimeStyle.left = oldRsLeft;
                return value;
            })(value);
        }
        return value;
    }

    return 0;
    /* eslint-enable */
};

// equivalent of PHP's stristr; a more dependable way
// of finding substrings
const containsStr = (needle, haystack) => {
    const charArray1 = needle.split('');
    const charArray2 = haystack.split('');

    let match = 0;

    for (let i = 0; i < charArray1.length - charArray2.length + 1; i++) {
        match = 0;
        for (let j = 0; j < charArray2.length; j++) {
            if (charArray1[i + j] === charArray2[j]) {
                match = match + 1;
            }
            // console.log(i, j, match, charArray1[i+j], charArray2[j]);
            if (match === charArray2.length) {
                return true;
            }
        }
    }
    return false;
};

function getParameterByName(name, url) {
    let setName = name;
    let setUrl = url;

    if (!setUrl) {
        setUrl = window.location.href;
    }

    setName = setName.replace(/[[\]]/g, '\\$&'); // /[\[\]]/g

    const regex = new RegExp(`[?&]${setName}(=([^&#]*)|&|#|$)`); // '[?&]' + name + '(=([^&#]*)|&|#|$)'
    const results = regex.exec(setUrl);

    if (!results) {
        return null;
    }

    if (!results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// removes query string and hash from window.location.href
function stripLocation(url) {
    return url.split('?')[0].split('#')[0];
}

/* eslint-disable */
// Important to preserve this context
function debounce(func, wait, immediate) {
    let timeout;
    return function () {
        const context = this;
        const args = arguments;
        const later = () => {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
/* eslint-enable */

// gets hash parameters
const getHashParams = () => {
    const hashParams = {};
    let e = [];
    const r = /([^&;=]+)=?([^&;]*)/g;
    const q = window.location.hash.substring(1);

    /* eslint-disable */
    while ((e = r.exec(q))) {
        hashParams[e[1]] = decodeURIComponent(e[2]);
    }
    /* eslint-enable */

    return hashParams;
};

// generates random string
const generateRandomString = (length) => {
    let text = '';
    const possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let i = 0;

    for (i = 0; i < length; i++) {
        text =
            text + possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
};

// detects environment according to domain
const getEnv = () => {
    let env = 'production';

    if (
        window.location.href.match('localhost') &&
        window.location.port &&
        window.location.protocol === 'http:'
    ) {
        env = 'local';
    } else if (window.location.href.match('cabletv.dev')) {
        env = 'development';
    } else if (window.location.href.match('cabletv.staging')) {
        env = 'staging';
    } else {
        env = 'production';
    }

    return env;
};

// equivalent to PHP's in_array
const inArray = (needle, haystack) => {
    const length = haystack.length;
    for (let i = 0; i < length; i++) {
        if (haystack[i] === needle) {
            return true;
        }
    }
    return false;
};

// standard GET request (for retrieving JSON, etc.)
const getJSON = (url) => {
    const httpReq = new XMLHttpRequest();
    httpReq.open('GET', url, false);
    httpReq.send(null);
    return JSON.parse(httpReq.responseText);
};

// only allow numeric input and enter key from keyboard
const onlyAllowNumbers = (input) => {
    input.addEventListener('keydown', function (e) {
        if (isNaN(e.key) && e.key !== 'Backspace' && e.which !== 13) {
            e.preventDefault();
        }
    });
};

/**
 * Sets a cookie with the specified name, value, and optional expiration days.
 *
 * @param {string} name     - The name of the cookie (must be a non-empty string).
 * @param {string} value    - The value of the cookie (must be a string).
 * @param {number} [days=0] - The number of days until the cookie expires. Defaults to session-only if 0.
 * @throws {Error} If the name or value is not a valid string.
 */
const setCookie = (name, value, days = 0) => {
    if (!name || typeof name !== 'string') {
        throw new Error('Cookie name must be a non-empty string.');
    }

    if (typeof value !== 'string') {
        throw new Error('Cookie value must be a string.');
    }

    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(
        value
    )}; path=/`;

    if (days > 0) {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        cookieString += `; expires=${expires.toUTCString()}`;
    }

    document.cookie = cookieString;
};

const getCookie = (cname) => {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

export {
    bp,
    addClass,
    setClass,
    removeClass,
    hasClass,
    getStyle,
    stripLocation,
    containsStr,
    debounce,
    getParameterByName,
    getHashParams,
    generateRandomString,
    getEnv,
    getJSON,
    inArray,
    onlyAllowNumbers,
    setCookie,
    getCookie,
};
